// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 3t7wZMgJPQyyMw4DqH4rwx
// Component: 9QfkYiEQekIW
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import "@plasmicapp/react-web/lib/plasmic.css";
import * as defaultcss from "../plasmic__default_style.module.css"; // plasmic-import: global/defaultcss
import * as projectcss from "./plasmic_valentino.module.css"; // plasmic-import: 3t7wZMgJPQyyMw4DqH4rwx/projectcss
import * as sty from "./PlasmicValentinoBeauty.module.css"; // plasmic-import: 9QfkYiEQekIW/css
import logo3XpngESkE6BC9Z from "./images/logo3Xpng.png"; // plasmic-import: eSkE6bC9Z/picture

export const PlasmicValentinoBeauty__VariantProps = new Array();

export const PlasmicValentinoBeauty__ArgProps = new Array();

function PlasmicValentinoBeauty__RenderFunc(props) {
  const { variants, args, overrides, forNode, dataFetches } = props;
  return (
    <React.Fragment>
      <div className={defaultcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            defaultcss.all,
            projectcss.root_reset,
            sty.root
          )}
        >
          <div
            data-plasmic-name={"formBody"}
            data-plasmic-override={overrides.formBody}
            className={classNames(defaultcss.all, sty.formBody)}
          >
            <img
              data-plasmic-name={"logo"}
              data-plasmic-override={overrides.logo}
              alt={""}
              className={classNames(defaultcss.img, sty.logo)}
              role={"img"}
              src={logo3XpngESkE6BC9Z}
            />

            <div
              data-plasmic-name={"firstName"}
              data-plasmic-override={overrides.firstName}
              className={classNames(
                defaultcss.all,
                defaultcss.__wab_text,
                sty.firstName
              )}
            >
              {"First Name"}
            </div>

            <input
              data-plasmic-name={"firstNameTextbox"}
              data-plasmic-override={overrides.firstNameTextbox}
              className={classNames(defaultcss.input, sty.firstNameTextbox)}
              placeholder={"First Name"}
              size={1}
              type={"text"}
            />

            <div
              data-plasmic-name={"lastName"}
              data-plasmic-override={overrides.lastName}
              className={classNames(
                defaultcss.all,
                defaultcss.__wab_text,
                sty.lastName
              )}
            >
              {"Last Name"}
            </div>

            <input
              data-plasmic-name={"lastNameTextbox"}
              data-plasmic-override={overrides.lastNameTextbox}
              className={classNames(defaultcss.input, sty.lastNameTextbox)}
              placeholder={"Last Name"}
              size={1}
              type={"text"}
            />

            <div
              data-plasmic-name={"email"}
              data-plasmic-override={overrides.email}
              className={classNames(
                defaultcss.all,
                defaultcss.__wab_text,
                sty.email
              )}
            >
              {"Email"}
            </div>

            {true ? (
              <input
                data-plasmic-name={"emailTextbox"}
                data-plasmic-override={overrides.emailTextbox}
                className={classNames(defaultcss.input, sty.emailTextbox)}
                placeholder={"Email"}
                size={1}
                type={"text"}
              />
            ) : null}

            <button
              data-plasmic-name={"loginButton"}
              data-plasmic-override={overrides.loginButton}
              className={classNames(
                defaultcss.button,
                defaultcss.__wab_text,
                sty.loginButton
              )}
            >
              {"Login"}
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "formBody",
    "logo",
    "firstName",
    "firstNameTextbox",
    "lastName",
    "lastNameTextbox",
    "email",
    "emailTextbox",
    "loginButton"
  ],

  formBody: [
    "formBody",
    "logo",
    "firstName",
    "firstNameTextbox",
    "lastName",
    "lastNameTextbox",
    "email",
    "emailTextbox",
    "loginButton"
  ],

  logo: ["logo"],
  firstName: ["firstName"],
  firstNameTextbox: ["firstNameTextbox"],
  lastName: ["lastName"],
  lastNameTextbox: ["lastNameTextbox"],
  email: ["email"],
  emailTextbox: ["emailTextbox"],
  loginButton: ["loginButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = deriveRenderOpts(props, {
      name: nodeName,
      descendantNames: [...PlasmicDescendants[nodeName]],
      internalArgPropNames: PlasmicValentinoBeauty__ArgProps,
      internalVariantPropNames: PlasmicValentinoBeauty__VariantProps
    });

    const { dataFetches } = props;
    return PlasmicValentinoBeauty__RenderFunc({
      variants,
      args,
      overrides,
      dataFetches,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicValentinoBeauty";
  } else {
    func.displayName = `PlasmicValentinoBeauty.${nodeName}`;
  }
  return func;
}

export const PlasmicValentinoBeauty = Object.assign(
  // Top-level PlasmicValentinoBeauty renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    formBody: makeNodeComponent("formBody"),
    logo: makeNodeComponent("logo"),
    firstName: makeNodeComponent("firstName"),
    firstNameTextbox: makeNodeComponent("firstNameTextbox"),
    lastName: makeNodeComponent("lastName"),
    lastNameTextbox: makeNodeComponent("lastNameTextbox"),
    email: makeNodeComponent("email"),
    emailTextbox: makeNodeComponent("emailTextbox"),
    loginButton: makeNodeComponent("loginButton"),
    // Metadata about props expected for PlasmicValentinoBeauty
    internalVariantProps: PlasmicValentinoBeauty__VariantProps,
    internalArgProps: PlasmicValentinoBeauty__ArgProps
  }
);

export default PlasmicValentinoBeauty;
/* prettier-ignore-end */
